import { render, staticRenderFns } from "./targetAgainstUserLangk.vue?vue&type=template&id=4a94ac6c&scoped=true"
import script from "./targetAgainstUserLangk.vue?vue&type=script&lang=js"
export * from "./targetAgainstUserLangk.vue?vue&type=script&lang=js"
import style0 from "./targetAgainstUserLangk.vue?vue&type=style&index=0&id=4a94ac6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94ac6c",
  null
  
)

export default component.exports